export function addDays(days: number, date = new Date()): Date {
    const result = new Date(date);
    result.setTime(result.getTime() + days * 24 * 60 * 60 * 1000);
    return result;
}
